import { getTestId } from '@airtel/air-design-system';
var additionalBenefits = [{
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'OTT'
}, {
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'OTT'
}, {
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'OTT'
}, {
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'OTT'
}, {
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'OTT'
}, {
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'OTT'
}];
export var defaultProps = Object.assign({
  title: 'Postpaid • 9108266546',
  subTitle: '2GB/day • 28 days validity',
  priceDetails: {
    price: '₹599.00',
    oldPrice: '₹99.00',
    isOldPriceStriked: false
  },
  additionalBenefits: additionalBenefits,
  imageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  tertiaryActionButtonText: 'view details',
  infoTagText: 'text label',
  incrementalStepperProps: {
    size: 'sm',
    value: '1'
  },
  showAvatar: true,
  removeCardBorderRadius: true,
  removeMarginForActionButton: false,
  iconProps: {
    iconName: 'HomeIcon',
    variant: 'icon'
  }
}, getTestId('OrderSummaryCardWidgetContainer'));